// extracted by mini-css-extract-plugin
export default {"date":"styles_date__kga0q","pending":"styles_pending__-r8WT"};